import {translate} from 'views/module';

import CaregiverSupportChatAgentJob from './draft/types/CaregiverSupportChatAgentJob';
import EmailAgentJob from './draft/types/EmailAgentJob';
import InternalApiCallAgentJob from './draft/types/InternalApiCallAgentJob';
import PushNotificationAgentJob from './draft/types/PushNotificationAgentJob';
import SmsAgentJob from './draft/types/SmsAgentJob';
import TimerAgentJob from './draft/types/TimerAgentJob';
import UnknownAgentJob from './draft/types/UnknownAgentJob';

import {getParticipantType} from '../../communication/communicationUtils';
import {getResourceLabel} from './agentJobTypeUtils';

const agentJobTypes = [
  SmsAgentJob,
  EmailAgentJob,
  PushNotificationAgentJob,
  CaregiverSupportChatAgentJob,
  InternalApiCallAgentJob,
  TimerAgentJob,
];

const agentJobTypesByAction = agentJobTypes.reduce((result, agentJobType) => ({
  ...result,
  [agentJobType.actionType]: agentJobType,
}), {});

const getAgentJobType = (actionType) => {
  return agentJobTypesByAction[actionType] || UnknownAgentJob;
};

const getActionLabel = (job) => {
  const agentJobType = getAgentJobType(job.actionType);
  return agentJobType.label || job.actionType || translate('case.Detail.AgentJobs.UnknownAction');
};

const getDraftComponent = (actionType) => {
  return getAgentJobType(actionType).Draft;
};

const getDraftIcon = (actionType) => {
  return getAgentJobType(actionType).DraftIcon || null;
};

const getResourceTypeLabel = (participantDetails, resourceRn) => {
  if (!resourceRn) {
    return '';
  }

  const participantType = getParticipantType(resourceRn);

  if (participantType === 'Missing translation') {
    return '';
  }

  const loadedDetail = participantDetails?.[resourceRn]?.detail;

  if (loadedDetail?.caregiverRole) {
    return loadedDetail.caregiverRole;
  }

  return participantType;
};

const getDraftTitle = (job, participantDetails) => {
  const agentJobType = getAgentJobType(job.actionType);

  if (agentJobType.getDraftTitle) {
    return agentJobType.getDraftTitle(job, participantDetails);
  }

  return translate('case.Detail.AgentJobs.ToRecipient', {
    recipient: getResourceLabel(
        participantDetails,
        job.actionPayload?.resourceRn || job.resourceRn,
    ) || translate('case.Detail.AgentJobs.UnknownRecipient'),
  });
};

const getDraftSubtitle = (job, participantDetails) => {
  const agentJobType = getAgentJobType(job.actionType);

  if (agentJobType.getDraftSubtitle) {
    return agentJobType.getDraftSubtitle(job, participantDetails);
  }

  return getResourceTypeLabel(participantDetails, job.actionPayload?.resourceRn || job.resourceRn) ||
    getActionLabel(job);
};

const getDraftBody = (job) => {
  return getAgentJobType(job.actionType).getDraftBody(job);
};

const buildPayload = (job, context) => {
  return getAgentJobType(job.actionType).buildPayload(context);
};

const getListDetail = (job, participantDetails, executeAtLabel) => {
  return getAgentJobType(job.actionType).getListDetail(job, participantDetails, executeAtLabel);
};

export {
  buildPayload,
  getActionLabel,
  getDraftBody,
  getDraftComponent,
  getDraftIcon,
  getDraftSubtitle,
  getDraftTitle,
  getListDetail,
};
